// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--3j0bS","content":"layout-module--content--2HQo4"};